<template>

  <div>

    <div class="bg-white">
      <br class="d-none d-lg-block">
    	<br>
    	<div class="container py-1">
    	  <br class="d-none d-md-block">
    	  <div class="row">
    	    <div class="col-md-6">
            <p class="small grey text-uppercase mb-2"><a href="/trailer-rental">{{`Trailer Rental in ${countriesStr('and')}`}}</a>:</p>
    	      <h1 class="h2">Flatbed Trailer Rental</h1>
    	      <p class="lead grey">Rent a Flatbed Trailer with <strong>PNO Rental</strong> for your next transportation need.</p>
    				<hr>
    				<p class="text-lg d-none d-sm-block">Find a Flatbed Trailer that fit your transportation needs. Simply request your Flatbed Trailer available for short-term rental with PNO Rental</p>
    				<p><a href="/trailers?category=flatbed" class="btn btn-lg btn-success">Search Flatbed Trailers <i class="fa fa-chevron-right ml-1"></i></a></p>
    	    </div>
            <div class="col-md-6 col-xl-5 offset-xl-1">
                <img :src="require('@/assets/img/type_flatbed.jpg')" class="img-fluid mb-3" alt="Flatbed Trailer Rental">
            </div>
    	  </div>
    	</div>
    	<br class="d-none d-md-block">
    </div>

    <div class="container py-4">
    	<br class="d-none d-md-block">
    	<h2 class="h4">Flatbed Trailer Features</h2>
    	<p class="lead grey">Flatbed trailers are the most common choice for transportation of special goods.</p>
    	<hr>
    	<br>
    	<div class="row">
    	  <div class="col-md-4">
    			<h5>Standard</h5>
    			<p class="grey">Standard specification for transportation of bulky goods.</p>
    	  </div>
    	  <div class="col-md-4">
    			<h5>Mega</h5>
    			<p class="grey">Mega specification for transportation of high bulky goods.</p>
    	  </div>
    	</div>
        <hr>
    	<p class="small grey">The specifications listed are based upon PNO's most commonly rented trailers. They are not the exact measurements of all trailers rented by PNO. Specifications will vary by make, model and year of trailer.</p>
    </div>
  
  	<pno-how />

  	<pno-prompt />

  </div>

</template>

<script>
import PnoHow from '@/components/PnoHow.vue'
import PnoPrompt from '@/components/PnoPrompt.vue'
import { countriesStr } from '@/assets/countries';

export default {
	methods: {
		countriesStr
	},
    mounted() {
        this.$store.commit('meta/title', 'Flatbed Trailer for Short-term Rental')
        this.$store.commit('meta/description', 'Rent a Flatbed Trailer with PNO Rental for your next transportation need. Get your quote today!')
        this.$store.commit('meta/image', this.generateSmartImgUrl(require('@/assets/img/type_flatbed.jpg') , 'ogimage'));
    },
	components: { PnoHow, PnoPrompt },
}
</script>
